import gql from "graphql-tag";

const GET_APPLICATION_ID = gql`
  mutation addForm(
    $group_id: String
    $FormType: String!
    $formVersionId: Float
    $reuseMetadata: ReuseMetadataInput
    $modalAnswer: String
  ) {
    addForm(
      group_id: $group_id
      FormType: $FormType
      formVersionId: $formVersionId
      reuseMetadata: $reuseMetadata
      modalAnswer: $modalAnswer
    )
  }
`;

const DELETE_FORM = gql`
  mutation deleteForm($id: String!, $FormType: String!) {
    deleteForm(id: $id, FormType: $FormType)
  }
`;

// Deprecated - do not need to fetch all profiles in most cases
const GET_ALL_PROFILES = gql`
  query {
    getUserProfileInfo {
      EmployerProfiles {
        employer_id
        employer_name
      }
      EmployerPOCProfiles {
        employer_poc_id
        employer_poc_name
      }
      AgentProfiles {
        agent_id
        agent_name
      }
      AgentIndividualProfiles {
        agent_ind_id
        agent_ind_name
      }
      RecruiterProfiles {
        recruiter_id
        recruiter_name
        first_name
        last_name
        employer_name
        city
        state
        country
      }
      CropProfiles {
        crop_id
        crop_work_state
        crop_name
        crop_crop_id
        crop_agricultural_activity
      }
      AgricultureProfiles {
        agriculture_id
        agriculture_name
        agriculture_emp_name
        agriculture_state
        agriculture_county
      }
      WorkerHousingProfiles {
        workerHousing_id
        workerHousing_type_of_housing
        workerHousing_state
        workerHousing_state
        workerHousing_county
        workerHousing_name
      }
      MaterialTermsProfiles {
        material_terms_id
        material_terms_profile_name
        material_terms_section_number
        material_terms_summary
        material_terms_details
      }
      ForeignWorkerProfiles {
        foreign_worker_id
        foreign_worker_name
        foreign_worker_first_name
        foreign_worker_first_middle
        foreign_worker_last_name
        foreign_worker_address
        foreign_worker_city
        foreign_worker_state
        foreign_worker_province
        foreign_worker_country
        foreign_worker_postal_code
        foreign_worker_dob
        foreign_worker_class
        foreign_worker_alien_number
        foreign_worker_birth_country
        foreign_worker_citizen_country
        new_profile_fw_education {
          appAEduTypeId
          appAEduOther
          appAEduMajors
          appAEduInstName
          appAEduCountryId
          appAEduMonthYearAttained
        }
        new_profile_fw_training_qualifications {
          appATrainingInstName
          appATrainingName
          appATrainingCert
          appATrainingStartDate
          appATrainingEndDate
          appATrainingYearAwd
        }
        new_profile_fw_skills {
          appASkillsInstName
          appASkillsInstName
          appASkillsCountryId
          appASkillsStateId
          fwTerritory
          appASkillsSpecial
        }
        new_profile_fw_work_experience {
          appAExpEmpName
          appAExpAddress1
          appAExpAddress2
          appAExpCity
          appAExpPostalCode
          appAExpCountryId
          appAExpStateTerritory
          appAExpProvince
          appAExpJobTitle
          appAExpStartDate
          appAExpEndDate
          appAExpFWPresent
          appAExpWorkHour
          appAExpJobDuties
        }
      }
      ForeignWorkerGroupProfiles {
        foreign_worker_group_id
        new_group_fw_group_name
        new_group_fw_profiles
        new_group_fw_num_profiles
      }
    }
  }
`;

const GET_CASES_REUSE = gql`
  query getDatahubCasesForReuse($formId: String!, $formVersionId: [Float!]) {
    getDatahubCasesForReuse(formId: $formId, formVersionId: $formVersionId) {
      caseId
      caseNumber
      formId
      applicationId
      dateSubmitted
      empBusinessName
      suggestedSocCode
      suggestedSocTitle
      jobTitle
      empFein
      visaType
      externalStatus
    }
  }
`;

const GET_PAGINATED_CASES_REUSE = gql`
  query getPaginatedDatahubCasesForReuse(
    $formId: String!
    $formVersionId: [Float!]
    $UISorting: UISortingCases!
    $UISearch: UISearch!
  ) {
    getPaginatedDatahubCasesForReuse(
      formId: $formId
      formVersionId: $formVersionId
      UISorting: $UISorting
      UISearch: $UISearch
    ) {
      ReusableCases {
        caseId
        caseNumber
        formId
        formVersionId
        applicationId
        dateSubmitted
        empBusinessName
        suggestedSocCode
        suggestedSocTitle
        empFein
        visaType
        externalStatus
        jobTitle
        tempneedSoctitle
        tempneedSoccode
        submitDate
        disabled
      }
      total_count
    }
  }
`;

export {
  GET_APPLICATION_ID,
  DELETE_FORM,
  GET_ALL_PROFILES,
  GET_CASES_REUSE,
  GET_PAGINATED_CASES_REUSE,
};
